<template>
  <div>
    <div class="label">{{ textFloat }}</div>
    <div class="d-flex align-items-end">
      <div v-if="value" :class="[imageClassName, 'container-image-preview']">
        <img
          v-if="isImage"
          class="image-preview"
          :src="file"
          alt="your image"
        />
        <div
          v-else
          class="image-preview"
          :style="{
            'background-image': 'url(' + imagePath + value + ')',
          }"
        ></div>
        <div class="delete-image">
          <div class="btn-close zoom-shrink" @click="deleteImage()">
            <div class="close_icon zoom-shrink"></div>
          </div>
        </div>
      </div>
      <div v-else :class="className" @click="addImageUpload()">
        <div class="plus">+</div>
      </div>
      <b-button
        v-if="value"
        class="btn-image-upload"
        variant="none"
        @click="addImageUpload()"
      >
        <font-awesome-icon
          icon="file-upload"
          color="white"
          class="bg-icon mr-2"
        />
        <span class="mx-auto"> Attach file</span>
      </b-button>
      <input
        accept="image/png"
        type="file"
        :ref="name"
        hidden
        @input="handleImageUpload($event, $event.target.value)"
        @change="onImageChange($event)"
      />
    </div>

    <div class="mt-2">
      <small>{{ desc }}</small>
    </div>
  </div>
</template>
<script>
export default {
  // props: ["textFloat", "desc", "value", "name", "imagePath",],
  props: {
    textFloat: { required: false },
    desc: { required: false },
    value: { required: false },
    name: { required: false },
    imageClassName: {
      required: false,
    },
    imagePath: { required: false },
    className: { required: false, default: "image-upload-preview" },
  },
  data() {
    return {
      file: this.value,
      isImage: false,
    };
  },
  mounted() {},
  methods: {
    deleteImage() {
      this.file = "";
      this.$emit("deleteImage", this.name);
    },
    addImageUpload() {
      this.$refs[this.name].click();
    },
    async handleImageUpload(evt, value) {
      // var _URL = window.URL || window.webkitURL;
      // var img = new Image();
      // var objectUrl = _URL.createObjectURL(evt.target.files[0]);
      // img.onload = function () {
      //   alert(this.width + " " + this.height);
      //   _URL.revokeObjectURL(objectUrl);
      // };
      // img.src = objectUrl;
      if (evt.target.files[0].type != "image/png") {
        return this.$swal2.fire(
          "เกิดข้อผิดพลาด",
          "กรุณาอัพโหลดเฉพาะไฟล์ .PNG",
          "error"
        );
      }
      if (evt.target.files[0].size / 1024 / 1024 > 1) {
        return this.$swal2.fire(
          "เกิดข้อผิดพลาด",
          "กรุณาอัพโหลดขนาดไม่เกิน 1 MB",
          "error"
        );
      }
      const imageToBase64 = await this.encodeImageFileAsURL(evt.target);
      var that = this;
      imageToBase64.onload = function (e) {
        const value = e.target.result.replace("data:image/png;base64,", "");
        that.$emit("input", value);
      };
    },
    encodeImageFileAsURL(element) {
      return new Promise((resolve) => {
        var file = element.files[0];
        var reader = new FileReader();
        reader.readAsDataURL(file);
        resolve(reader);
      });
    },
    onImageChange(evt) {
      this.isImage = true;
      const file = evt.target.files;
      if (file && file.length > 0) {
        this.file = window.URL.createObjectURL(file[0]);
      }
    },
  },
};
</script>
<style lang="scss">
.btn-image-upload {
  color: #fff;
  display: flex;
  align-items: center;
  background-color: var(--primary-color);
  border: 1px solid var(--primary-color);
  min-width: 120px;
  margin-left: 5px;
}

small {
  color: #929293;
}
.image-preview {
  height: 150px;
  min-height: 150px;
  min-width: 150px;
  width: 150px;
  object-fit: contain;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  align-items: center;
  border: 2px dashed #bfbfbf;

  position: relative;
}

.btn-close-image-preview {
  position: relative;
}
.image-upload-preview {
  height: 150px;
  width: 150px;
  display: flex;
  justify-content: center;
  position: relative;
  cursor: pointer;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  align-items: center;
  border: 2px dashed #bfbfbf;
}
.plus {
  font-size: 32px;
  font-weight: bold;
  color: var(--primary-color);
}
.delete-image {
  top: 2px;
  position: absolute;
  right: 5px;
}
.btn-close {
  position: relative;
  width: 2em;
  height: 2em;
}
.btn-close:before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 0;
  width: 0;
  border: 1em solid rgba(100, 100, 100, 0.8);
  border-radius: 6em;
  transition: all 0.2s ease-in-out;
}
.close_icon {
  transition: all 0.075s ease-in-out;
  position: absolute;
  width: 2em;
  height: 2em;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 0.1em solid;
  border-color: rgba(250, 250, 250, 0.8);
  border-radius: 6em;
  cursor: pointer;
}
.close_icon:after {
  transition: all 0.075s ease-in-out;
  font: 1em Helvetica, arial;
  font-size: 1em;
  width: 100%;
  height: 100%;
  content: "x";
  color: rgba(250, 250, 250, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translate(0, -5%) scale(1.25, 1);
}

.btn-close.zoom-shrink:hover .close_icon.zoom-shrink {
  font-size: 1.2em;
}

.btn-close.zoom-shrink:active .close_icon.zoom-shrink:after {
  font-size: 0.75rem;
  color: rgba(50, 50, 50, 0.8);
}
.container-image-preview {
  position: relative;
}
</style>
